import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDeleteTranscript = (caseId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const deleteTranscript = async (transcriptId: string) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.DELETE,
    });

    const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/transcripts/${transcriptId}`, fetchConfig);
    if (!response.ok) {
      throw new Error('Deleting transcript failed');
    }
  };

  return useMutation({
    mutationFn: (transcriptId: string) => deleteTranscript(transcriptId),
    onSuccess: (_data, transcriptId) => {
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Transcripts, { caseId }] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Transcript, transcriptId] });
    },
  });
};
